// extracted by mini-css-extract-plugin
export default {"LeagueTab":"LeagueTab_LeagueTab__ELHdl","shadow":"LeagueTab_shadow__3ZTgE","title":"LeagueTab_title__rB0LI","stat":"LeagueTab_stat__5XoxB","gradient":"LeagueTab_gradient__+BsrR"};